import { createSlice } from "@reduxjs/toolkit";
const initialState = {
	orgData: [],
  clinicsData: []
};
const orgSlice = createSlice({
  name: "organization",
  initialState: initialState,
  reducers: {
    orgListing(state, action) {
      state.orgData = action.payload;
    },
    clinicListing(state, action) {
      state.clinicsData = action.payload;
    }
  }
});
export const orgActions = orgSlice.actions;
export default orgSlice;
